import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { getUserList, getUserListCount } from "../../services/ api_services";
import Pagination from "../Pagination";
import SelectMenu from "../SelectMenu";

const SearchReferrerDialog = ({ onClose, onSelect, orgTree }) => {

    const adminOrgId = sessionStorage.getItem("adminOrgId");

    const initialCond = {
        search_word: "",
        search_type: "",
        search_org: null
    };

    const searchType = [
        { name: "성명",     id: "name" },
        { name: "전화번호", id: "phone" },
        { name: "이메일",   id: "email" },
    ];

    const [cond, setCond] = useState(initialCond);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [search, setSearch] = useState("");
    const [selected, setSelected] = useState(searchType[0]);
    const [list, setList] = useState([]);
    const [orgTreeList, setOrgTreeList] = useState(orgTree);

    const handleSelect = (item) => {

        // item.org_id 로 발행가능할 때만 넘어가도록 해야함
        // 해당 org_id의 트리 찾기 함수
        const findOrgById = (orgList, targetId) => {
            for (const org of orgList) {
                if (Number(org.id) === targetId) return org;
                if (org.children) {
                const found = findOrgById(org.children, targetId);
                if (found) return found;
                }
            }
            return null;
        };

        const orgInTree = findOrgById(orgTreeList, item.org_id);
        if ((Number(orgInTree.total_coupon) || 0) - (Number(orgInTree.issued_coupon) || 0) - (Number(orgInTree.referrer_count) || 0) <= 0) {
            alert(`${item.user_nm} 님의 보유 회원권이 없습니다. 추천인 등록이 불가능합니다.`);
            return;
        }

        onSelect(item);
        onClose();
    };

    useEffect(() => {
        
        const data = {
            page_number: currentPage,
            page_size: pageSize,
            search_word: cond.search_word,
            search_type: selected.id,
            search_org: null,
            view_referrer: "True",  // org_id 값을 가진 회원(추천인 후보)만 보이도록 True값
            admin_level_cd: '',
            admin_org_id: adminOrgId,
        };

        fetchUserList(data);

    }, [currentPage, pageSize]);

        /**
     * 전체 카운트 API
     * @returns
     */
    const fetchTotalCount = async (data) => {
        console.log("🚀 ~ SearchReferrerDialog fetchTotalCount ~ data:", data);
        try {
            const response = await getUserListCount(data);
            console.log("🚀 ~ SearchReferrerDialog fetchTotalCount ~ response:", response);
            if (response && response.status === 200) {
                console.log("SearchReferrerDialog response.data ==>", response.data);
                if (response.data) {
                    setTotalCount(Number(response.data));
                } else {
                    setTotalCount(0);
                }
            } else {
                setTotalCount(0);
            }
        } catch (e) {
            console.log("e===>", e);
        }
    };

        /**
     * 이름, 핸드폰 번호 조회 함수
     * @returns
     */
    async function fetchUserList(data) {

        console.log("SearchReferrerDialog data ==>", data);
        try {
            const response = await getUserList(data);
            console.log("🚀 ~ SearchReferrerDialog fetchUserList ~ response:", response);

            if (response.status === 200 && !isEmpty(response.data)) {
                console.log("SearchReferrerDialog response.data ==>", response.data);
                setList(response.data);
                setCurrentPage(1);
                setTotalPages(Math.ceil(response.data.length / pageSize));
                setTotalCount(response.data.length);
            } else {
                setList([]);
                // console.log("response===>", response);
            }
        } catch (e) {
            console.log("e===>", e);
        }
    }

    function handleOnSearch() {

        let condTemp = {
            page_number: 1,
            page_size: pageSize,
            search_word: cond.search_word,
            search_type: selected.id,
            search_org: null,
            view_referrer: "True",
            admin_level_cd: '',
            admin_org_id: adminOrgId,
        };

        fetchUserList(condTemp);
    }


    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
        <div className="bg-white rounded-md p-6 w-[800px]">
            <div className="flex gap-2 mb-4">
                <SelectMenu options={searchType} onSelect={setSelected} selectedId={selected.id} />
                <input
                    type="text"
                    placeholder="검색어 입력"
                    value={search}
                    className="border p-2 flex-1"
                    onChange={(e) => {
                        setCond((preVal) => {
                            return {
                                ...preVal,
                                search_word: e.target.value.trim(),
                            };
                        });
                        setSearch(e.target.value);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleOnSearch();
                        }
                    }}
                />
                <button 
                    className="bg-black text-white px-4 py-2 rounded"
                    onClick={() => handleOnSearch() }
                >검색</button>
            </div>

            <table className="w-full border text-sm text-center">
            <thead className="bg-gray-800 text-white">
                <tr>
                <th>NO</th>
                <th>성명</th>
                <th>휴대전화번호</th>
                <th>회원구분(조직)</th>
                <th></th>
                </tr>
            </thead>
            <tbody>
                {list.map((item, idx) => (
                <tr key={item.id} className="border-b">
                    <td>{(idx+1) + (currentPage-1)*pageSize}</td>
                    <td>{item.user_nm}</td>
                    <td>{item.user_hp_no}</td>
                    <td className="text-left">{item.org_full_path}</td>
                    <td>
                    <button
                        onClick={() => handleSelect(item)}
                        className="bg-gray-300 px-2 py-1 rounded"
                    >
                        선택
                    </button>
                    </td>
                </tr>
                ))}
            </tbody>
            </table>

            <Pagination
                onChangeCurrentPage={(val) => setCurrentPage(val)}
                onChangeTotalPages={(val) => setTotalPages(val)}
                totalCount={totalCount}
                itemsPerPage={pageSize}
            />

            <div className="mt-4 text-center">
            <button onClick={onClose} className="bg-gray-600 text-white px-4 py-2 rounded">
                닫기
            </button>
            </div>
        </div>
        </div>
    );
};

export default SearchReferrerDialog;